import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { formatPhoneNumberIntl  } from 'react-phone-number-input'
const myStyle = {
    background: "#6EA3D5",
    padding: "8px",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
};

const type_list = [
    {
        value: 'kiosk_to_kiosk',
        text: 'Kiosk to Kiosk'
    },
    {
        value: 'kiosk_to_pp',
        text: 'Kiosk to Point'
    },
    {
        value: 'kiosk_to_locker',
        text: 'Kiosk to Locker'
    },
    {
        value: 'kiosk_to_door',
        text: 'Kiosk to Door'
    },
    {
        value: 'pp_to_pp',
        text: 'Point to Point'
    },
    {
        value: 'pp_to_locker',
        text: 'Point to Locker'
    },
    {
        value: 'pp_to_kiosk',
        text: 'Point to Kiosk'
    },
    {
        value: 'pp_to_door',
        text: 'Point to Door'
    }
]


const PageTitle = ({title}) => (
    <Typography variant="h6" style={myStyle} fontWeight={"bold"}>
        {title}
    </Typography>
);

function Summary({...props}) {
    
    const parcel_price = (props.type.includes('pp_')) ? props.data.parcelSizes.rates.find(obj => obj.service_level.code === props.data.parcelPrice) : { price: 0, service_level: {dimensions: ''}};
    const { width, height, length, weight } = parcel_price?.service_level?.dimensions;
    const { name: service_name } = parcel_price?.service_level;
    useEffect(() => {
        window.scrollTo(0, 0);
        console.log(props);
    },[])

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <div>
                <PageTitle title="Summary" />
                <div className="p-3 bg-[#FFFFFF] rounded-b-lg">
                    <div className="font-semibold text-[#868686]">Parcel Summary</div>
                    <div className="mt-1 font-semibold text-[#2B549A]">{service_name}</div>
                    {(props.type.includes('pp_')) && (
                        <>
                            <div className="mt-2 font-semibold text-[#000000]">{`${width}cm X ${height}cm X ${length}cm - ${weight}kg`}</div>
                            <div className="mt-5"><span className="font-semibold rounded-md py-1 px-4 bg-[#E6E7E8] text-[#000000]">R{parcel_price.rate}</span></div>
                        </>
                    )}
                </div>
            </div>
            <div>
                <PageTitle title="Sender Details" />
                <div className="p-3 bg-[#FFFFFF] rounded-b-lg">
                    <div className="font-semibold text-[#000000]">Name and Surname: {props.data.senderName}</div>
                    <div className="mt-1  text-zinc-400">Phone Number: { formatPhoneNumberIntl(props.data.senderNumber) }</div>
                    <div className="mt-1  text-zinc-400">Email Address: {props.data.senderEmail }</div>
                </div>
            </div>
            <div>
                <PageTitle title="Recipient Details" />
                <div className="p-3 bg-[#FFFFFF] rounded-b-lg">
                    <div className="font-semibold text-[#000000]">Name and Surname: {props.data.receiverName}</div>
                    <div className="mt-1 text-zinc-400">Phone Number: { formatPhoneNumberIntl(props.data.receiverNumber )}</div>
                    <div className="mt-1 text-zinc-400">Email Address: {props.data.receiverEmail }</div>
                </div>
            </div>
            <div>
                <PageTitle title="Delivery Location" />
                <div className="p-3 bg-[#FFFFFF] rounded-b-lg">
                    {
                        (props.data.service_type.includes('_door')) ? (
                            <div>
                                <div className="text-zinc-400">Address Line 1: {props.data.entered_address}</div>
                                <div className="text-zinc-400">Address Line 2: </div>
                                <div className="text-zinc-400">Suburb: {props.data.suburb}</div>
                                <div className="text-zinc-400">City: {props.data.city}</div>
                                <div className="text-zinc-400">Postal Code: {props.data.postCode}</div>
                            </div>
                        ) : (
                            <div>
                                <div className = "text-zinc-400">Address Line 1: {props.data.selectedLocker.address.address}</div>
                                <div className="text-zinc-400 mt-">Address Line 2: </div>
                                <div className="mt-1 text-zinc-400">City: {props.data.selectedLocker.address.locality}</div>
                                <div className="mt-1 text-zinc-400">Postal Code: {props.data.selectedLocker.address.postal_code}</div> 
                            </div>
                        )
                    }
                </div>
            </div>
          
        </Box>
    );
}

export default Summary;
